import querystring from 'query-string';
import { SearchFilters } from '../types/search';

const searchFiltersToQuery = (filters?: SearchFilters): string => {
  if (!filters) return '';
  return querystring.stringify(filters, { arrayFormat: 'comma' });
};

export default searchFiltersToQuery;
